(function () {
    const gallery = document.getElementById('smallGallery');
    if (!gallery) {
        return;
    }
    let modal;

    function createMenu() {

        function createMoreLink(item, extraHtml, buttonLabel) {
            item.classList.add('more-media-link');
            gallery.appendChild(item);
            const link = item.querySelector('a');
            link.setAttribute('inert', '');
            link.insertAdjacentHTML('beforeend', extraHtml);
            item.insertAdjacentHTML('beforeend', `<button class="hidden-button" aria-label="${buttonLabel}"></button>`);
            return item.querySelector('.hidden-button');
        }

        function openModal(mode) {
            if (!modal) modal = createModal(imageItems, videoItems);
            modal.open(mode);
        }

        const originalItems = [...gallery.querySelectorAll('[data-media-type]')];
        const imageItems = originalItems.filter(it => it.dataset.mediaType === 'image');
        const videoItems = originalItems.filter(it => it.dataset.mediaType !== 'image');
        const maxImages = 5;
        const staticImageItems = imageItems.slice(0, maxImages);
        const moreImageItems = imageItems.slice(maxImages);
        const hasMoreImages = moreImageItems.length > 0;
        const hasVideos = videoItems.length;
        staticImageItems.forEach(it => it.querySelector('a')?.addEventListener('mouseover', (event) => event.target.click()));
        if (hasMoreImages) {
            moreImageItems.forEach(it => it.remove());
            const link = createMoreLink(
                moreImageItems[0].cloneNode(true),
                `<span class="more-images-number">${moreImageItems.length}+</span>`,
                'More Images');
            link.addEventListener('click', (event) => {
                event.preventDefault();
                openModal('images');
            });
        }
        if (hasVideos) {
            videoItems.forEach(it => it.remove());
            const link = createMoreLink(
                videoItems[0].cloneNode(true),
                `<span class="video-icon"></span>
<span class="more-videos-number">${videoItems.length} Videos</span>`,
                'Videos');
            link.addEventListener('click', (event) => {
                event.preventDefault();
                openModal('videos');
            });
        }


        document.querySelectorAll('a[href="#amazon-style-modal"]').forEach(it => {
            if (!hasMoreImages && !hasVideos) {
                it.remove();
            }
            it.addEventListener('click', (event) => {
                event.preventDefault();
                openModal(hasMoreImages ? 'images' : 'videos');
            })
        });
    }

    function createModal(imageItems, videoItems) {
        return new class {
            constructor() {
                const dialog = document.getElementById('amazon-style-modal');
                this.dialog = dialog;
                document.body.appendChild(dialog);
                const hasTabs = imageItems.length > 0 && videoItems.length > 0;
                if (!hasTabs) {
                    dialog.classList.add('no-tabs');
                }
                dialog.querySelectorAll('a[data-mode]').forEach(it => it.addEventListener('click', event => {
                    event.preventDefault();
                    this._selectTab(it.dataset.mode);
                }));
                dialog.querySelector('.button-close').addEventListener('click', () => {
                    dialog.close();
                });
                dialog.addEventListener('close', () => {
                    this.dialog.querySelectorAll('.tab-main').forEach(it => it.replaceChildren());
                });
                this._createTab('images', imageItems);
                this._createTab('videos', videoItems);
            }

            _createTab(mode, items) {
                this.dialog.querySelector(`#mode-${mode} .item-gallery`).append(...items.map(it => it.cloneNode(true)));
                this.dialog.querySelectorAll(`#mode-${mode} .item-gallery a`).forEach((it, i) => {
                    it.addEventListener('click', (event) => {
                        event.preventDefault();
                        this._selectItem(mode, i);
                    });
                });
            }

            _selectTab(mode) {
                this.dialog.querySelectorAll('.tab-content').forEach(it => it.classList.remove('selected'));
                this.dialog.querySelectorAll('a.tab').forEach(it => it.classList.remove('selected'));
                this.dialog.querySelector(`.tab-content#mode-${mode}`)?.classList.add('selected');
                this.dialog.querySelector(`a.tab[href="#mode-${mode}"]`)?.classList.add('selected');
                this._selectItem(mode, 0);
            }

            _selectItem(mode, index) {
                let selectedItem;
                this.dialog.querySelectorAll(`#mode-${mode} .item-gallery a`).forEach((it, i) => {
                    it.classList.toggle('selected', i === index);
                    if (i === index) {
                        selectedItem = it;
                    }
                });
                const main = this.dialog.querySelector(`#mode-${mode} .tab-main`);
                this.dialog.querySelectorAll('.tab-main').forEach(it => {
                    it.replaceChildren();
                });
                if (selectedItem) {
                    const template = selectedItem.querySelector('template');
                    if (template) {
                        main.append(document.importNode(template.content, true));
                    } else {
                        main.insertAdjacentHTML('beforeend', `<img src="${selectedItem.dataset.image}" data-zoom-image="${selectedItem.dataset.zoomImage}" alt=""/>`);
                        createZoom(main.querySelector('img'));
                    }
                }
            }

            open(mode) {
                this.dialog.showModal();
                this._selectTab(mode);
            }
        }
    }

    function createZoom(img) {
        const src = img.dataset.zoomImage;
        if (!src) {
            return;
        }
        let isHover = false;
        let isLoaded = false;
        let mouseEvent;
        img.parentNode.insertAdjacentHTML('beforeend', `<img src="${src}" class="zoom-image" alt=""/>`);
        const zoomImage = img.parentNode.querySelector('img.zoom-image');
        const scale = 1.8;
        zoomImage.style.transform = `scale(${scale})`;
        zoomImage.style.transformOrigin = `top left`;
        zoomImage.style.opacity = '0';
        zoomImage.style.pointerEvents = 'none';
        zoomImage.addEventListener('load', () => {
            isLoaded = true;
            if (isHover) {
                start();
            }
        });
        const start = () => {
            zoomImage.style.opacity = '1';
            img.style.opacity = '0';
            img.style.cursor = 'crosshair';
            move();
        };
        const move = (event) => {
            if (event) {
                mouseEvent = event;
            }
            if (mouseEvent) {
                const x = Math.round(mouseEvent.offsetX * (1 - scale));
                const y = Math.round(mouseEvent.offsetY * (1 - scale));
                zoomImage.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
            }
        };
        img.addEventListener('mouseenter', (event) => {
            isHover = true;
            mouseEvent = event;
            img.addEventListener('mousemove', move);
            if (isLoaded) {
                start();
            }
        });
        img.addEventListener('mouseleave', (event) => {
            isHover = false;
            img.removeEventListener('mousemove', move);
            zoomImage.style.opacity = '0';
            img.style.opacity = '1';
            img.style.cursor = '';
        });
    }

    createMenu();
})();